import React from 'react';

const Loader = () => (
  <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[200]">
    <div className="w-16 h-16 border-4 border-t-transparent border-blue-500 border-solid rounded-full animate-spin"></div>
  </div>
);

export default Loader;
